module.exports = __webpack_public_path__ + "img/ecosystem_01_avalanche2.a43506f0.png";